export const trans_15_1=[
  {
    id:1,
    english:'What language are you learning? I am learning Vietnamese',
    vietnamese:'Bạn đang học tiếng gì? Tôi đang học tiếng Việt',
    user_message:''
  },
  {
    id:2,
    english:'My sister lived i Russia for a year',
    vietnamese:'Chị gái tôi đã ở Nga được một năm rồi',
    user_message:''
  },
  {
    id:3,
    english:'I went to work in H oChi Minh city last year',
    vietnamese:'Tôi đến thành phố Hồ Chí Minh năm ngoái',
    user_message:''
  },
  {
    id:4,
    english:'Could you tell Jake about the party by e-mail?',
    vietnamese:'Bạn có thể nói với Jake về bữa tiệc gữa e-mail được không?',
    user_message:''
  },  
  {
    id:5,
    english:'Richard has passed his driving test',
    vietnamese:'Richard đã vượt qua bài thi lái xe của anh ấy',
    user_message:''
  }, 

]

export const trans_15_2=[
  {
    id:1,
    english:'What is your purpose here? I come here to learn',
    vietnamese:'Mục đích của bạn khi đến đây la gi? Tôi muốn đến đây để học hỏi',
    user_message:''
  },
  {
    id:2,
    english:'How long have you been workinghere? I have been working for a long time',
    vietnamese:'Bạn làm việc ở đây lâu chưa? Tôi đã làm việc trong một thời gian dài',
    user_message:''
  },
  {
    id:3,
    english:'We are going to discover Vietnam through a movie',
    vietnamese:'Chúng ta sẽ khám phá đất nước Việt Nam qua một bộ phim',
    user_message:''
  },
  {
    id:4,
    english:'How many language can he speak? He can speak Japanese and French',
    vietnamese:'Anh ấy nói được ngôn ngữ nào? anh ấy biết nói tiếng Nhật và tiếng Pháp',
    user_message:''
  }, 
  {
    id:5,
    english:'Where did you buy this book? I bought it in a bookstore located near Ho Guom',
    vietnamese:'Cuốn sách này bạn mua ở đâu? Tôi mua nó ở hiên sách gần Hồ Cườm',
    user_message:''
  },  

]